import React, { FC } from 'react';

type Props = {
  value: string;
  variant: 'danger' | 'success';
};

export const Badge: FC<Props> = ({ value, variant }) => {
  const variantStyles = {
    danger: 'border-red-500 bg-red-100',
    success: 'border-green-500 bg-green-100',
  };

  return (
    <div className={`${variantStyles[variant]} rounded border-2 py-1 px-2 mx-1 text-sm`}>
      <span>{value}</span>
    </div>
  );
};
